let systemConfig = window.systemConfig
export default {
  // 企信
  // {{$t('chat.memo')}}
  // $t('chat.memo')
  // this.$t('chat.memo')
  chat: {
    qixin: systemConfig && systemConfig.qixin ? systemConfig.qixin.zh : '企信',
    open: '展开',
    communicate: '点击可以与同事实时沟通',
    Initiatechat: '发起聊天',
    groupchat: '选择群聊',
    chat: '聊天',
    seemore: '查看更多消息',
    unread: '未读',
    already: '已读',
    peoplehaveread: '人已读',
    allread: '全部已读',
    withdraw: '撤回',
    Noannouncement: '暂无群公告',
    Groupmembers: '群成员',
    Addmember: '添加成员',
    manage: '管理员',
    Groupchatstaff: '群聊全员',
    Groupannouncement: '群公告',
    transfer: '转让群聊',
    topchat: '置顶聊天',
    toptalk: '置顶会话',
    dissolve: '解散群聊',
    quit: '退出群聊',
    expression: '表情',
    newmessage: '条新消息',
    entersend: '按Enter发送消息',
    send: '发送',
    view: '查看群聊',
    quitTip: '退出后，你将不再接受该群组中的消息，请谨慎操作。你确定要退出群聊吗？',
    dissolveTip: '提示：解散后，该群聊不可恢复，群聊中的成员将收到解散消息，请谨慎操作。',
    dissolve2: '你确定要解散群聊吗？',
    selectmember: '选择成员',
    readnotread: '已读未读',
    messagedetails: '消息详情',
    read: '已读',
    notread: '未读',
    groupmemberlist: '@群成员列表',
    draft: '草稿',
    everyone: '所有人',
    message_empty: '不能发送空白消息！',
    person: '人',
    recalled1: '对方撤回了一条消息',
    recalled2: '你撤回了一条消息',
    recalled3: '撤回了一条消息',
    you: '你',
    message_long: '消息内容超长，请分条发送！',
    selecttransfer: '请选择转让成员！',
    welcome: '欢迎',
    jointhisgroup: '加入本群',
    adminwill: '管理员将',
    removegroup: '移出群聊',
    messagecenter: '消息中心',
    markallread: '全部标记为已读',
    modulename: '模块名称',
    robot: '机器人',
    onlyunread: '只查看未读消息',
    noauthority: '无权查看或数据已删除',
    addmemo: '新增备忘录',
    // 20210305
    residueprocessingtime: '剩余处理时间',
    hasatimeout: '已超时'
  }
}
